import axios from "axios";
import config from "../config";
import { CompanyDropdownDto } from "./Dtos/EventsDtos";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = config.API_URL;

export const HelpersService = {
  getStatesDropdown: () => {
    const fullUrl = `api/Helpers/StatesDropdown`;
    return axios.get(fullUrl);
  },
  getCompaniesDropdown: async (): Promise<CompanyDropdownDto[]> => {
    const response = await axios.get<CompanyDropdownDto[]>(
      "/api/v1/helpers/dropdown/companies",
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
};

export type StatesDropdownResponse = {
  code: string;
  name: string;
};
